import { useCallback } from 'react';

import usePaginationData from '@/hooks/pure/useFetchData';
import service from '@/services/index';
import { CUSTOMER_PAGE_SIZE } from '@/stores/CustomerStore';
import { getPaginationQueries } from '@/utils/pagination';
import { buildQuery, pushEntryIntoQueryArr } from '@/utils/util';

const useShortCustomerList = (
  defaultQueryKey: string,
  defaultQueryValue: string,
) => {
  const fetchQueryCustomerList = useCallback(
    async (
      prevData: PaginatedData<CustomerT>[],
      currPage: number,
      targetPage?: number,
    ) => {
      const paginationQueryArr = getPaginationQueries({
        queries: {},
        prevData: prevData || [],
        targetPage: targetPage,
        currPage,
        sortby: 'name',
        order: 'asc',
        cursorKey: 'paginate_token',
        acc: !!targetPage,
      });

      const queryArr = pushEntryIntoQueryArr([...paginationQueryArr], {
        [defaultQueryKey]: defaultQueryValue,
      });

      const query = buildQuery(queryArr);
      const res = await service.contact.fetchCustomerList(query);
      return res;
    },
    [defaultQueryKey, defaultQueryValue],
  );

  const [
    customers,
    customerLoading,
    hasCustomerNext,
    customerNextClickHandler,
    page,
  ] = usePaginationData(
    fetchQueryCustomerList,
    defaultQueryValue,
    CUSTOMER_PAGE_SIZE,
    'paginate_token',
  );

  return {
    customers,
    customerLoading,
    hasCustomerNext,
    page,
    customerNextClickHandler,
  };
};

export default useShortCustomerList;
